<template>
    <div class="container">
        <div class="page-title">Категории</div>
        <div class="section categories">
            <category-card
                    v-for="card in cards"
                    :title="card.title"
                    :img="card.img"
                    :items="card.items"
            ></category-card>
        </div>
    </div>
</template>

<script>
    import CategoryCard from '../components/Cards/CategoryCard2';
    export default {
        name: "CategoriesPage",
        components: { CategoryCard },
        data() {
            return {
                cards: [
                    {
                        title: 'Електроника',
                        items: [
                            'Экшн камеры',
                            'Смарт часы',
                            'Power Bank',
                            'Гироскутеры',
                            'Беспроводные наушники',
                            'Портативные колонки',
                            'Проводные наушники',
                            'Другие товары',
                        ],
                        img: 'cat2.svg'
                    },
                    {
                        title: 'Экотовары',
                        items: [
                            'Посуда',
                            'Личная гигиена',
                            'Парфюмерия',
                            'Другие товары',
                        ],
                        img: 'cat2.svg'
                    },
                    {
                        title: 'Красота и здоровье',
                        items: [
                            'Косметика',
                            'Уход за руками и ногами',
                            'Массажеры',
                            'Уход за волосами',
                            'Корректирующее белье',
                            'Другие товары',
                        ],
                        img: 'cat2.svg'
                    },
                    {
                        title: 'Товары для дома',
                        items: [
                            'Товары для кухни',
                            'Дом и интерьер',
                            'Сад и огород',
                            'Кружки и термосы',
                            'Бытовая техника',
                            'Лампы и освещение',
                            'Товары для ремонта',
                            'Другие товары',
                        ],
                        img: 'cat2.svg'
                    },
                    {
                        title: 'Наручные часы',
                        items: [
                            'Механические часы',
                            'Умные часы',
                            'Мужские часы',
                            'Спортивне часы',
                            'Кварцевые часы',
                            'Популярные часы',
                            'Женские часы',
                            'Коробки и футляры',
                        ],
                        img: 'cat2.svg'
                    },
                    {
                        title: 'Украшения и бижутерия',
                        items: [
                            'Цепочки',
                            'Кольца',
                            'Серьги',
                            'Наборы украшений',
                            'Браслеты',
                            'Кулоны и подвески',
                            'Брелки',
                            'Другие товары',
                        ],
                        img: 'cat2.svg'
                    },
                    {
                        title: 'Автомобили и мотоциклы',
                        items: [
                            'Видеорегистраторы',
                            'Навигаторы',
                            'Инструменыт и уход',
                            'Антибликовые очки',
                            'Держатели для телефонов',
                            'Внутренние аксессуары',
                            'Внешние аксессуары',
                            'Другие товары',
                        ],
                        img: 'cat2.svg'
                    },
                    {
                        title: 'Хобби, спорт, путешествия',
                        items: [
                            'Спортивные товары',
                            'Фитнес-браслеты',
                            'Походные рюкзаки',
                            'Путешествия и пляж',
                            'Бинокли и монокляры',
                            'Рыбалка и охота',
                            'Фонари и лампы',
                            'Другие товары',
                        ],
                        img: 'cat2.svg'
                    },
                    {
                        title: 'Товары для взрослых',
                        items: [
                            'Мужчине',
                            'Женщине',
                            'Для двоих'
                        ],
                        img: 'cat2.svg'
                    }
                ]
            }
        }

    };
</script>

<style scoped lang="scss">
    .categories {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
</style>
